import CaseReportService from './CaseReportService';
import ICaseReportService from './ICaseReportService';
import MockCaseReportService from './MockCaseReportService';

export default class CaseReportServiceFactory {
  caseReportService: CaseReportService;

  constructor() {
    this.caseReportService = new CaseReportService();
  }

  create(mode: string): ICaseReportService {
    if (mode.startsWith('test')) {
      return new MockCaseReportService(mode);
    } else {
      return this.caseReportService;
    }
  }
}
